<template>
  <section class="app-transporte">
    <v-container grid-list-xl style="max-width: 600px">
      <v-layout row wrap>
        <v-flex lg12 sm12 xs12>
          <section class="d-flex justify-center">
            <img width="130" src="@/assets/vai-vem/vaivem-icon.svg" />
          </section>
          <v-card outlined class="app-card">
            <v-card-title class="app-card-title justify-space-between"
            >VaiVem
              <v-btn @click="logout()" depressed>
                Sair
                <v-icon right>fa-arrow-right</v-icon>
              </v-btn>
            </v-card-title>
            <v-alert
              outlined
              type="warning"
              prominent
              border="left"
              class="ma-3"
              v-if="alert"
            >
              {{ msg }} Nenhum resultado para essa busca, verifique o CPF e
              tente novamente
            </v-alert>
            <v-card-text class="app-card-content">
              <v-form ref="form" lazy-validation @submit.prevent="onSubmit">
                <v-row>
                  <v-col :md="12" :sm="12" :xs="12" cols="12">
                    <v-text-field
                      v-model="form.cpf"
                      placeholder="Digite o CPF"
                      v-mask="'###.###.###-##'"
                      label="CPF*"
                      :rules="[rules.required]"
                      filled
                      rounded
                      dense
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col :md="12" :sm="12" :xs="12" cols="12">
                    <v-text-field
                      v-model="form.dataNascimento"
                      placeholder="Digite a Data de Nascimento"
                      type="date"
                      label="Data de Nascimento*"
                      :rules="[rules.required, rules.validateData]"
                      filled
                      rounded
                      dense
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
              <div class="loading" v-if="isLoading">
                <v-progress-circular
                  :size="25"
                  color="primary"
                  indeterminate
                ></v-progress-circular>
              </div>
            </v-card-text>
            <v-card-actions class="d-flex justify-center">
              <v-btn @click="search()" depressed large color="primary">
                Consultar
              </v-btn>
            </v-card-actions>
          </v-card>
          <br />
        </v-flex>
      </v-layout>
    </v-container>
    <DialogConfirmacaoEntrega
      :dialog="dialogConfirmacao"
      :dados="dados"
      :confirmation="confirmation"
      :onClose="()=>dialogConfirmacao = false"
    />
    <DialogAlertDesempregado
      :alertDesempregado="alertDesempregado"
      :onClose="()=>alertDesempregado=false"
    />
    <DialogErrorDesempregado
      :alertErrorDesempregado="alertErrorDesempregado"
      :onClose="()=>alertErrorDesempregado=false"
    />
    <DialogAtendimentoVue
      :dataAluno="carteiraEntregue"
      :dialog="openDialog"
      :closeDialog="closeDialog"
      v-if="carteiraEntregue"
      :isAluno="false"
    ></DialogAtendimentoVue>
  </section>
</template>

<script>
import VaiVemService from "@/services/vai-vem.service";
import GlobalStore from "@/store/modules/global";
import DialogAtendimentoVue from "../components/DialogAtendimento.vue";
import vaiVemService from "@/services/vai-vem.service";
import FunctionsCommuns from "@/util/FunctionsCommuns";
import DialogConfirmacaoEntrega from "@/views/transportes/vai-vem/components/DialogConfirmacaoEntrega.vue";
import dayjs from "dayjs";
import DialogErrorDesempregado from "@/views/transportes/vai-vem/components/DialogErrorDesempregado.vue";
import DialogAlertDesempregado from "@/views/transportes/vai-vem/components/DialogAlertDesempregado.vue";
import {router} from "@/router";
import VaiVemAuthService from "@/services/vai-vem.auth.service";

export default {
  metaInfo: {
    title: "VaiVem",
  },
  components: {DialogAlertDesempregado, DialogErrorDesempregado, DialogConfirmacaoEntrega, DialogAtendimentoVue },
  data: () => ({
    isLoading: false,
    form: {
      cpf: null,
      dataNascimento: null
    },
    rules: {
      required: (value) => !!value || "Esse campo deve ser preenchido",
      validateData: (value) => FunctionsCommuns.isValidDate(FunctionsCommuns.formatBRDate(value)) || "Data invalida",
    },
    openDialog: false,
    alert: false,
    msg: "",
    dados: {},
    dateNow: Date.now(),
    dialogConfirmacao: false,
    carteiraEntregue: null,
    alertErrorDesempregado: false,
    alertDesempregado: false
  }),
  methods: {
    alertError(){
      GlobalStore.setSnackBar({
        show: true,
        message: "A comunicação com o sistema do IDT está fora do ar, por favor tentar novamente mais tarde!",
        type: "error",
        timeout: 6000,
      });
    },
    search() {
      const isValid = this.$refs.form.validate();
      if (isValid) {
        this.isLoading = true;
        const { cpf, dataNascimento } = this.form;
        vaiVemService.loginDetran().subscribe({
          next: ()=>{
            VaiVemService.findByDesempregado([cpf], FunctionsCommuns.formatBRDate(dataNascimento)).subscribe({
              next: (res) => {
                const {data: {situacao, nome, local_retirada, recebido_em}} = res
                if(situacao === "disponivel_para_retirada"){
                  this.dados = {nome, cpf, dataNascimento: FunctionsCommuns.formatBRDate(dataNascimento)}
                  this.dialogConfirmacao = true;
                }else if(situacao === "cartao_entregue"){
                  this.carteiraEntregue = {
                    nome_pessoa: nome,
                    endereco: local_retirada,
                    dtSolicitacao: recebido_em
                  }
                  this.openDialog = true
                }else{
                  this.alertDesempregado = true;
                }
                this.isLoading = false;
              },
              error: (res)=>{
                this.alertErrorDesempregado = true
                this.isLoading = false;
              }
            })
          },
          error: (error)=>{
           this.alertError()
          }
        })
      }
    },
    confirmation() {
      vaiVemService.loginDetran().subscribe({
        next: ()=>{
          VaiVemService.confirmaEntregaDesempregado(this.dados['cpf'], FunctionsCommuns.formatBRDate(dayjs())).subscribe(
            (res) => {
              GlobalStore.setSnackBar({
                show: true,
                message: "Entrega realizada com sucesso!",
                type: "success",
                timeout: 3000,
              });
              this.dialogConfirmacao = false;
            },
            (err) => {
              this.alertError()
              console.error(err);
            }
          );
        },
        error: (error)=>{
          this.alertError()
        }
      })
    },
    logout() {
      VaiVemAuthService.logout(null, null, false)
    },
    closeDialog() {
      this.openDialog = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.loading {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  text-align: center;
  .v-progress-circular {
    margin: auto;
  }
}
</style>
